/* Obolpay theme controller — light/dark with persistence.
 *
 * Pair with the no-flash inline snippet in <head> BEFORE any stylesheet. This
 * module wires any [data-theme-toggle] element to flip + persist the theme. */

type Theme = 'light' | 'dark';
const KEY = 'obol-theme';
const root = document.documentElement;
const bound = new WeakSet<Element>();

function current(): Theme {
  const attr = root.getAttribute('data-theme');
  if (attr === 'light' || attr === 'dark') return attr;
  return matchMedia('(prefers-color-scheme:dark)').matches ? 'dark' : 'light';
}
function apply(theme: Theme): void {
  root.setAttribute('data-theme', theme);
  try { localStorage.setItem(KEY, theme); } catch { /* private mode */ }
  root.dispatchEvent(new CustomEvent('themechange', { detail: { theme } }));
}
function toggle(): void { apply(current() === 'dark' ? 'light' : 'dark'); }

window.ObolTheme = { current, apply, toggle };

function bind(): void {
  for (const el of Array.from(document.querySelectorAll('[data-theme-toggle]'))) {
    if (bound.has(el)) continue;
    bound.add(el);
    el.addEventListener('click', toggle);
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
else bind();
document.addEventListener('obol:rendered', bind);
